// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__NgiUD","primary":"Button_primary__zCRdE","second":"Button_second__1oTD5"};